/**
 * @module app.shared
 */

import tzParseTimezone from 'date-fns-tz/_lib/tzParseTimezone';
import { subMilliseconds } from 'date-fns';

export function mapTimeZone(timeZone: string) {
    if(!timeZone || timeZone === 'browser') {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return timeZone;
}

export function isTimeZoneUtc(timeZone: string): boolean {
    if(!timeZone) { return false; }
    return /^(?:Etc\/)?UTC$/i.test(timeZone);
}

export function changeLocalTimeZone(utcDate: Date, timeZone: string) {
    // eventually, utcToZonedTime from date-fns-tz can be used
    // there is a bug causing it to fail on the day DST starts https://github.com/marnusw/date-fns-tz/issues/31
    // for now, this is a workaround from https://github.com/marnusw/date-fns-tz/pull/51

    // We just need to apply the offset indicated by the time zone to this localized date
    const offsetMilliseconds = tzParseTimezone(timeZone, utcDate);
    const zonedDate = offsetMilliseconds ? subMilliseconds(utcDate, offsetMilliseconds) : utcDate;

    // This date has the UTC time values of the zoned date at the system time zone
    return new Date(
        zonedDate.getUTCFullYear(),
        zonedDate.getUTCMonth(),
        zonedDate.getUTCDate(),
        zonedDate.getUTCHours(),
        zonedDate.getUTCMinutes(),
        zonedDate.getUTCSeconds(),
        zonedDate.getUTCMilliseconds()
    );
}
